import type { ISidebarLink } from "@/types/layout/navigation";
import { cn } from "@/utils/css";
import Icon from "@dinesapp/dines-ui/components/Icon";
import Tippy from "@tippyjs/react/headless";

interface ISideBarItem {
  collapseSidebar: boolean;
  selected: string;
  item: ISidebarLink;
}

const SideBarItem: React.FC<ISideBarItem> = ({
  collapseSidebar,
  selected,
  item,
}) => {
  const isSelected = selected === item.id;
  const isDanger = item.id === "logout";

  const row = (
    <div
      className={cn(
        "group mb-1 flex h-12 w-full cursor-pointer items-center rounded-xl px-4 text-lg transition-all duration-150 md:text-base",
        collapseSidebar && "md:mx-auto md:w-12 md:justify-center md:px-0",
        isSelected
          ? "bg-white/5 ring-1 ring-white/10"
          : isDanger
            ? "hover:bg-red-500/10"
            : "hover:bg-white/5",
      )}
    >
      {item.icon && (
        <Icon
          icon={item.icon}
          size="lg"
          className={cn(
            "shrink-0 transition-colors duration-150",
            isSelected
              ? "text-dines-green"
              : isDanger
                ? "text-gray-400 group-hover:text-red-500"
                : "text-gray-400 group-hover:text-white",
          )}
        />
      )}
      <span
        className={cn(
          "mt-1 ml-4 flex-1 overflow-hidden truncate whitespace-nowrap md:max-w-52",
          isSelected
            ? "font-bold text-white"
            : isDanger
              ? "text-gray-200 group-hover:text-red-500"
              : "text-gray-200",
          collapseSidebar && "md:hidden",
        )}
      >
        {item.name}
      </span>
      {isSelected && (
        <span
          aria-hidden
          className={cn(
            "ml-2 h-2 w-2 max-w-2 shrink-0 rounded-full bg-dines-green",
            collapseSidebar && "md:hidden",
          )}
        />
      )}
    </div>
  );

  return (
    <Tippy
      disabled={!collapseSidebar}
      placement="right"
      offset={[0, 24]}
      delay={[100, 0]}
      trigger="mouseenter"
      touch={false}
      hideOnClick
      zIndex={40}
      appendTo={() => document.body}
      render={(attrs) => (
        <div
          {...attrs}
          className={cn(
            "hidden whitespace-nowrap rounded-lg px-3 py-2 font-medium text-sm shadow-xl ring-1 backdrop-blur-xl md:block",
            isDanger
              ? "bg-red-500/80 text-white ring-red-300/30"
              : "bg-dines-purple-darkest/70 text-white ring-white/20",
          )}
        >
          {item.name}
        </div>
      )}
    >
      {row}
    </Tippy>
  );
};

export default SideBarItem;
